import env from '@jwp/ott-common/src/env';

export const buildSanityImageUrl = (ref: string, width?: number, height?: number, quality?: number): string => {
  if (!ref) return '';

  const assetId = ref.replace('image-', '').replace(/-png$|-jpg$|-jpeg$|-webp$/, '');
  const extension = ref.split('-').pop() || 'jpg';

  let url = `https://cdn.sanity.io/images/${env.APP_SANITY_PROJECT_ID}/${env.APP_SANITY_DATASET}/${assetId}.${extension}`;

  const params = new URLSearchParams();
  if (width) params.append('w', width.toString());
  if (height) params.append('h', height.toString());
  if (quality) params.append('q', quality.toString());
  params.append('auto', 'format');

  const queryString = params.toString();
  if (queryString) {
    url += `?${queryString}`;
  }

  return url;
};
